// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".espot-container{grid-column:1/6}.espot-plp-top{grid-row:2}.espot-plp-middle{grid-row:5}@media screen and (max-width:1024px){.espot-container{grid-column:1/3}.espot-plp-middle{grid-row:10}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
